import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 平台埋点跟踪（二期）
 * - 路由变化上报 pageview（fire-and-forget，失败静默，不阻塞业务）
 * - 每 60 秒上报一次在线心跳（sessionId 去重，用于「在线用户数」统计）
 * 隐私说明：仅记录 path/referrer/匿名 sessionId，不采集输入内容。
 */
const HEARTBEAT_MS = 60 * 1000;
const IGNORE_PREFIX = ['/admin', '/api', '/auth', '/health'];

function getSessionId(): string {
  const KEY = 'aibak_analytics_sid';
  try {
    let sid = localStorage.getItem(KEY);
    if (!sid) {
      sid = 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return 'anon-session';
  }
}

function send(kind: 'event' | 'heartbeat', payload: Record<string, unknown>): void {
  try {
    const sid = getSessionId();
    const body = kind === 'heartbeat'
      ? { sessionId: sid, path: window.location.pathname }
      : { sessionId: sid, ...payload };
    navigator.sendBeacon?.(`/api/analytics/${kind}`, new Blob([JSON.stringify(body)], { type: 'application/json' }))
      || fetch(`/api/analytics/${kind}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          keepalive: true,
        }).catch(() => {});
  } catch { /* 埋点失败不影响业务 */ }
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (IGNORE_PREFIX.some((p) => path.startsWith(p))) return;
    send('event', { type: 'pageview', path, referrer: document.referrer || '' });
  }, [location.pathname]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      if (IGNORE_PREFIX.some((p) => window.location.pathname.startsWith(p))) return;
      send('heartbeat', {});
    }, HEARTBEAT_MS);
    return () => window.clearInterval(timer);
  }, []);

  return null;
}
